import { yyyy, zzzz } from "../../store.svelte";
import maplibregl from "maplibre-gl";

let outageMarkers = [];

function createOutageIcon(number, isHighlighted = false) {
	const el = document.createElement('div');
	el.className = isHighlighted ? 'outage-icon highlighted' : 'outage-icon';
	el.innerHTML = `<span class="outage-number">${number}</span>`;
	return el;
}

export function initOutageMarkers(map) {
	// Listen for outage data changes
	zzzz.on('outages-updated', () => {
		updateOutageMarkers(map);
	});

	// Listen for outages being cleared
	zzzz.on('outages-cleared', () => {
		clearOutageMarkers();
	});

	// Listen for individual outage removal
	zzzz.on('removeOutage', () => {
		console.log('removeOutage event received, current outages:', yyyy.outages.length);
		// Use setTimeout to ensure the array modification happens first
		setTimeout(() => {
			updateOutageMarkers(map);
		}, 0);
	});

	// Listen for hover events from other components
	zzzz.on('highlight-outage', (outageIndex) => {
		highlightOutageMarker(outageIndex);
	});

	zzzz.on('unhighlight-outage', (outageIndex) => {
		unhighlightOutageMarker(outageIndex);
	});
}

function updateOutageMarkers(map) {
	console.log('updateOutageMarkers called, current outages:', yyyy.outages?.length || 0);
	// Remove existing outage markers
	outageMarkers.forEach(markerData => markerData.marker.remove());
	outageMarkers = [];

	// Add new outage markers
	if (yyyy.outages && yyyy.outages.length > 0) {
		yyyy.outages.forEach((outage, index) => {
			// Extract coordinates from outage data
			let coords = null;
			
			if (outage.clkd && outage.clkd.lng && outage.clkd.lat) {
				coords = [outage.clkd.lng, outage.clkd.lat];
			} else if (outage.coordinates) {
				coords = outage.coordinates;
			} else if (outage.lng && outage.lat) {
				coords = [outage.lng, outage.lat];
			} else if (outage.geometry && outage.geometry.coordinates) {
				coords = outage.geometry.coordinates;
			}

			if (coords) {
				const el = createOutageIcon(index + 1);
				
				// Add mouseover events
				el.addEventListener('mouseenter', () => {
					el.className = 'outage-icon highlighted';
					// Emit event for other components to react
					zzzz.emit('outage-hover', { outage, index });
				});
				
				el.addEventListener('mouseleave', () => {
					el.className = 'outage-icon';
					zzzz.emit('outage-unhover', { outage, index });
				});

				el.addEventListener('click', () => {
					zzzz.emit('outage-click', { outage, index });
				});

				const marker = new maplibregl.Marker({ 
					element: el,
					offset: [-15, -15] // Center the 30px icon
				})
					.setLngLat(coords)
					.addTo(map);
				
				outageMarkers.push({ marker, element: el, outage, index });
			}
		});
	}
}

function highlightOutageMarker(outageIndex) {
	const markerData = outageMarkers.find(m => m.index === outageIndex);
	if (markerData) {
		markerData.element.className = 'outage-icon highlighted';
	}
}

function unhighlightOutageMarker(outageIndex) {
	const markerData = outageMarkers.find(m => m.index === outageIndex);
	if (markerData) {
		markerData.element.className = 'outage-icon';
	}
}

export function clearOutageMarkers() {
	outageMarkers.forEach(marker => marker.marker.remove());
	outageMarkers = [];
}

// Export for manual updates
export { updateOutageMarkers };